import { axiosInstance } from '../App'
import { SECURED_API_BASE } from './apiConfig'
import {
  HealthEntityNomenclatorDTO,
  HealthEntityNomenclatorOptionsDTO,
  HealthEntityNomenclatorRequestDTO,
} from '../dto/HealthEntityNomenclatorDTO'

const BASE = `${SECURED_API_BASE}/health-entity-nomenclators`

export function getHealthEntityNomenclators(): Promise<HealthEntityNomenclatorDTO[]> {
  return axiosInstance.get(BASE).then(r => r.data ?? [])
}

export function getHealthEntityNomenclatorOptions(): Promise<HealthEntityNomenclatorOptionsDTO> {
  return axiosInstance.get(`${BASE}/options`).then(r => r.data)
}

export function createHealthEntityNomenclator(body: HealthEntityNomenclatorRequestDTO): Promise<HealthEntityNomenclatorDTO> {
  return axiosInstance.post(BASE, body).then(r => r.data)
}

export function updateHealthEntityNomenclator(id: number, body: HealthEntityNomenclatorRequestDTO): Promise<HealthEntityNomenclatorDTO> {
  return axiosInstance.put(`${BASE}/${id}`, body).then(r => r.data)
}

export function deleteHealthEntityNomenclator(id: number): Promise<void> {
  return axiosInstance.delete(`${BASE}/${id}`).then(() => undefined)
}
